export default __webpack_public_path__ + "static/media/shoe-1.3459a5bd.png";